import Card from '~/components/Card'
import Icon from '~/components/Icon'
import PaymentGatewaysManager from '~/layers/PaymentGatewaysManager'

/**
 * Pestaña Pasarelas: con qué cobra esta empresa en línea.
 *
 * A diferencia del resto de pestañas, ésta **no forma parte del formulario de la
 * empresa**: las pasarelas son su propia tabla, con sus credenciales cifradas y
 * su botón de probar. Por eso no recibe `form` ni se guarda con el botón de
 * abajo — cada pasarela se guarda al aceptar su modal.
 *
 * No confundir con la pestaña **Pagos**, que son los datos bancarios que salen
 * impresos en las cuentas de cobro.
 */
function TabPasarelas(props: { companyId: string }) {
  return (
    <Card>
      <Card.Title>
        <div class="flex items-center">
          <Icon icon="material-symbols-light:credit-card-outline" size={20} class="mr-2" />
          <h2 class="text-xl font-semibold">Pasarelas de pago</h2>
        </div>
      </Card.Title>
      <Card.Body>
        <p class="text-sm text-foreground-subtle mb-4">
          Con qué cobra esta empresa las compras del catálogo en línea. La marcada por defecto es la que se usa; si no hay ninguna, se cobra con la pasarela del sistema.
        </p>

        <PaymentGatewaysManager companyId={props.companyId} />
      </Card.Body>
    </Card>
  )
}

export default TabPasarelas
